import {connect} from 'react-redux'
import {
    ActionsRow,
    commons,
    FixedDropDownButton,
    Icon,
    Loader,
    modal,
    utils
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, Label, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as ciselnikActions from "../../actions/ciselnikActions";
import CiselnikApi from "../../api/gen/cgo/CiselnikApi";
const {sinkEvent} = commons;
import UkonForm from "../../forms/UkonForm";
import TablePanel from "../../components/TablePanel";
import {toastr} from "react-redux-toastr";
import ZmenitPoradiModal from "../../components/ZmenitPoradiModal";
import CustomCheckbox from "../../components/CustomCheckbox";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka administrace - Úkony
 */
class UkonyPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchUkonyIfNeeded());
    };

    handleCreateUkon = () => {
        const {ukonyList, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            UkonForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.createUkon(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateUkony());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {poradi: ukonyList.rows.length + 1}
            },
            t('new_operation'),
            {size: "xl", className: "card-form-modal"}
        ));
    };

    handleEditUkon = (ukon) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            UkonForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.updateUkon(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateUkony());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: ukon
            },
            t('operation_change'),
            {size: "xl", className: "card-form-modal"}
        ));
    };

    handleZmenitPoradi = () => {
        const {ukonyList, dispatch, t} = this.props;
        if (ukonyList.rows.length !== 0) {
            this.props.dispatch(modal.ModalActions.show(
                ZmenitPoradiModal,
                {
                    onOrderChanged: (changedIdsMap) => {
                        CiselnikApi.updatePoradiUkonu(changedIdsMap).then(() => {
                            dispatch(modal.ModalActions.hide());
                            dispatch(ciselnikActions.invalidateUkony());
                        });
                    },
                    items: ukonyList.rows,
                    renderItem: i => {
                        return <CardBody key={i.item.id}>
                            <Row>
                                <Col xs={12}>{i.item.nazevUkon}</Col>
                            </Row>
                        </CardBody>;
                    },
                },
                t('change_in_order'),
                {size: "lg", className: "card-form-modal"}
            ));
        } else {
            toastr.warning("Žádné úkony k řazení");
        }
    };

    handleVcetneNeaktivnich = (e) => {
        const {ukonyList} = this.props;
        this.props.dispatch(ciselnikActions.filterUkony({
            ...ukonyList.filter,
            vcetneNeaktivnich: e.target.checked
        }, false));
    };

    renderContextMenu = (ukon) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditUkon.bind(this, ukon))}>{t('edit')}</DropdownItem>
        </FixedDropDownButton>
    }

    renderUkonPolozka = (ukonPolozka, index) => {
        return <span key={index} className={ukonPolozka.neaktivni ? "mb-2 neaktivni muted" : "mb-2"}>{(index >= 1 ? " | " : "") + ukonPolozka.popisUkon}</span>;
    };


    render() {
        const {ukonyList, t} = this.props;
        let content;
        if (ukonyList.fetched) {
            if (ukonyList.rows.length !== 0) {
                content = ukonyList.rows.map(ukon => {
                    return <CardBody key={ukon.id} className={ukon.neaktivni ? "neaktivni" : ""}>
                        <ActionsRow actions={this.renderContextMenu(ukon)} onClick={this.handleEditUkon.bind(this, ukon)}>
                            <Row>
                                {/*<Col xs={1}>{ukon.poradi}</Col>*/}
                                <Col xs={3}>{ukon.nazevUkon}</Col>
                                <Col xs={1}>{ukon.povinne ? t('yes') : t('no')}</Col>
                                <Col xs={1}>{ukon.neaktivni ? t('no') : t('yes')}</Col>
                                <Col xs={3}>{ukon.polozky.map((p, i) => this.renderUkonPolozka(p, i))}</Col>
                                {/*<Col xs={3}>{ukon.polozky.map(p => <Label className={p.neaktivni ? "neaktivni" : ""}>{p.popisUkon+", "}</Label>)}</Col>*/}
                            </Row>
                        </ActionsRow>
                    </CardBody>;
                });
            } else {
                content = <CardBody><i>{t('no_operations')}</i></CardBody>
            }
        } else {
            content = <Loader/>
        }
        const vcetneNeaktivnich = ukonyList.filter.vcetneNeaktivnich || false;
        return <AdminPage className="ukony-page-content"
            title={t('admin.operations_many')}
            subtitle={t('admin.system_operator_operations')}
            content={
                <div>
                    <ButtonToolbar>
                        <Button color="primary" onClick={this.handleCreateUkon}>{t('new_m')}</Button>
                        <Button color="secondary" onClick={this.handleZmenitPoradi}>{t('change_order')}</Button>
                        <CustomCheckbox label={t('including_inactive')} value={vcetneNeaktivnich} onChange={this.handleVcetneNeaktivnich}/>
                    </ButtonToolbar>
                    <TablePanel header={
                        <Row>
                            {/*<Col xs={1}>Pořadí</Col>*/}
                            <Col xs={3}>{t('labels.name')}</Col>
                            <Col xs={1}>{t('labels.required')}</Col>
                            <Col xs={1}>{t('active')}</Col>
                            <Col xs={3}>{t('labels.items')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        ukonyList: utils.storeFromArea(state, ciselnikActions.UKONY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(UkonyPage));
